import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";

import {
  selectStyle,
  selectTheme,
  Container,
  Filters,
  SelectWrapper,
  Title,
  SubTitle,
  TabWrapper,
  TabTitle,
  Label,
  Content,
  Categories,
  Grid,
  CheckItem,
  Wrapper,
  SelectAll,
  TitleInput,
  InputWrapper,
  Input,
  WrapperCenter,
  BackgroundSelected,
  CheckedCircle,
  CheckMark,
  Modal
} from "./style";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Checkbox from "../../components/Checkbox";
import Button from "../../components/Button";
import LoadingIcon from "../../components/icons/LoadingIcon";

import { Creators as ProductsActions } from "../../store/ducks/products";

import phoneSvg from "../../assets/svg/phone.svg";

import { banners } from "../../components/constants/banners";

import {
  getEditSetup,
  setEditSetup,
  persistData,
  getStoreId,
  getStoreName,
  getBannerImage,
  getDepartmentName,
  getBanner1Title,
  getBanner1Subtitle,
  getBanner2Title,
  getBanner2Subtitle
} from "../../services/auth";

const Setup = () => {
  let history = useHistory();

  const stores = useSelector(state => state.products.stores);
  const categories = useSelector(state => state.products.categories);
  const loading = useSelector(state => state.products.loading);
  const loadingCategories = useSelector(
    state => state.products.loadingCategories
  );

  const [section, setSection] = useState("categories");
  const [storeId, setStoreId] = useState(getStoreId());
  const [storeName, setStoreName] = useState(getStoreName());
  const [departmentName, setDepartmentName] = useState(
    getDepartmentName() || ""
  );
  const [bannerImage, setBannerImage] = useState(getBannerImage() || "");
  const [banner1Title, setBanner1Title] = useState(getBanner1Title() || "");
  const [banner1Subtitle, setBanner1Subtitle] = useState(
    getBanner1Subtitle() || ""
  );
  const [banner2Title, setBanner2Title] = useState(getBanner2Title() || "");
  const [banner2Subtitle, setBanner2Subtitle] = useState(
    getBanner2Subtitle() || ""
  );
  const [selectAll, toggleSelectAll] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();

  const handleCategoryCheck = id => {
    let newCategories = [...categories];

    let category = categories.find(category => category._id === id);
    category.isSelected = !category.isSelected;

    dispatch(ProductsActions.setCategories(newCategories));
  };

  const handleSelectAll = () => {
    const newCategories = categories.map(category => ({
      ...category,
      isSelected: !selectAll
    }));

    toggleSelectAll(!selectAll);
    dispatch(ProductsActions.setCategories(newCategories));
  };

  const handleSelectStore = selection => {
    if (selection.store_id === storeId) return;

    setStoreId(selection.store_id);
    setStoreName(selection.name);
  };

  const handleFilterCategories = selection => {
    let filteredCategories;

    if (selection) {
      filteredCategories = categories.map(category => {
        return category._id === selection._id
          ? { ...category, hidden: false }
          : { ...category, hidden: true };
      });
    } else {
      filteredCategories = categories.map(category => ({
        ...category,
        hidden: false
      }));
    }

    dispatch(ProductsActions.setCategories(filteredCategories));
  };
  const handleSubmit = () => {
    persistData({
      storeId,
      storeName,
      departmentName,
      bannerImage,
      banner1Title,
      banner1Subtitle,
      banner2Title,
      banner2Subtitle,
      selectedCategories: categories
        .filter(category => category.isSelected)
        .map(category => category._id)
        .join(",")
    });

    setShowModal(true);
  };

  const setUpButtonStyle = {
    backgroundColor: "#78BE20",
    color: "#fff",
    borderColor: "#78BE20"
  };

  const onButtonClick = () => {
    setEditSetup("false");
    history.push("/home");
  };

  const ModalCmp = () => (
    <Modal opacity={showModal}>
      <div>
        <img alt="cadastro-concluido" src={phoneSvg} />
        <p>Totem Cadastrado com Sucesso!</p>
        <div>
          <button
            style={setUpButtonStyle}
            type="button"
            onClick={onButtonClick}
          >
            IR PARA TOTEM
          </button>
        </div>
      </div>
    </Modal>
  );

  useEffect(() => {
    if (getEditSetup() === "false") {
      history.push("/home");
    } else {
      dispatch(ProductsActions.getStoresRequest());
      dispatch(ProductsActions.getCategoriesRequest());
    }
  }, [dispatch, history]);

  return (
    <>
      <Header />

      <Container loadingCategories={loadingCategories}>
        <Title>Configure o sistema para começar a usar</Title>
        <TabWrapper>
          <TabTitle
            isSelected={section === "categories"}
            onClick={() => setSection("categories")}
          >
            <p>Departamento</p>
            <div />
          </TabTitle>

          <TabTitle
            isSelected={section === "banner"}
            onClick={() => setSection("banner")}
          >
            <p>Banner</p>
            <div />
          </TabTitle>

          <TabTitle
            isSelected={section === "descanso-de-tela"}
            onClick={() => setSection("descanso-de-tela")}
          >
            <p>Descanso de Tela</p>
            <div />
          </TabTitle>
        </TabWrapper>

        <Content
          hidden={section !== "categories"}
          loadingCategories={loadingCategories}
        >
          <Filters>
            <SelectWrapper>
              <Label>Selecione sua Loja</Label>

              <Select
                options={stores}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ store_id }) => store_id}
                defaultValue={
                  storeName ? { name: storeName, store_id: storeId } : ""
                }
                placeholder="Selecione a Unidade"
                isSearchable={false}
                isLoading={loading}
                loadingMessage={() => "Carregando lojas..."}
                styles={selectStyle}
                onChange={handleSelectStore}
                theme={defaultTheme => ({
                  ...defaultTheme,
                  colors: {
                    ...defaultTheme.colors,
                    ...selectTheme
                  }
                })}
              />
            </SelectWrapper>

            <SelectWrapper>
              <Label>Busque uma Categoria</Label>

              <Select
                options={categories}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ _id }) => _id}
                placeholder="Buscar Categoria"
                isSearchable
                isClearable
                isLoading={loadingCategories}
                loadingMessage={() => "Carregando categorias..."}
                styles={selectStyle}
                onChange={handleFilterCategories}
                theme={defaultTheme => ({
                  ...defaultTheme,
                  fontSize: 18,
                  lineHeight: "24px",
                  colors: {
                    ...defaultTheme.colors,
                    ...selectTheme
                  }
                })}
              />
            </SelectWrapper>
          </Filters>

          {loadingCategories || !categories.length ? (
            <WrapperCenter>
              <LoadingIcon />
            </WrapperCenter>
          ) : (
            <Categories>
              <Wrapper>
                <Label>Selecione as Categorias da Unidade</Label>
                <SelectAll onClick={handleSelectAll}>{`${
                  selectAll ? "Des" : "S"
                }elecionar todas`}</SelectAll>
              </Wrapper>

              <Grid>
                {categories
                  .filter(category => !category.hidden)
                  .map(category => (
                    <CheckItem key={category._id}>
                      <Checkbox
                        checked={category.isSelected}
                        onChange={() => handleCategoryCheck(category._id)}
                      />
                      <span>{category.name}</span>
                    </CheckItem>
                  ))}
              </Grid>
            </Categories>
          )}
        </Content>

        <Content hidden={section !== "banner"}>
          <InputWrapper>
            <Label>Dê um nome ao Departamento </Label>

            <Input
              name="departmentName"
              placeholder="'Cozinha'"
              value={departmentName}
              onChange={e => setDepartmentName(e.target.value)}
            />
          </InputWrapper>

          <TitleInput>Selecione a Imagem do Departamento</TitleInput>
          <SubTitle>
            *Essa imagem deve representar o grupo de categorias selecionadas
            anteriormente
          </SubTitle>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: 32,
              justifyContent: "space-between"
            }}
          >
            {banners.map(banner => (
              <div
                style={{
                  width: "47%",
                  marginTop: 16,
                  marginBottom: 16,
                  cursor: "pointer",
                  position: "relative"
                }}
                onClick={() => setBannerImage(banner.value)}
                onChange={() => setBannerImage(banner.value)}
              >
                <CheckedCircle isSelected={bannerImage === banner.value} />
                <CheckMark isSelected={bannerImage === banner.value} />
                <BackgroundSelected isSelected={bannerImage === banner.value} />
                <img
                  alt="decoracao-img"
                  value={banner.value}
                  style={{ width: "100%", height: "100%" }}
                  src={banner.image}
                />
              </div>
            ))}
          </div>
        </Content>

        <Content hidden={section !== "descanso-de-tela"}>
          <SubTitle>Configure o(s) descanso(s) de tela</SubTitle>
          <SubTitle>
            *Esses textos devem compor as mensagens que apareceram no totem
            quando ele estiver em modo de descanso
          </SubTitle>

          <TitleInput>Descanso de Tela 1</TitleInput>

          <InputWrapper>
            <Label>Título do Banner</Label>

            <Input
              minLength={4}
              maxLength={16}
              name="banner1Title"
              placeholder="‘Veja aqui!’"
              value={banner1Title}
              onChange={e => setBanner1Title(e.target.value)}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>Subtítulo do Banner</Label>

            <Input
              maxLength={45}
              name="banner1Subtitle"
              placeholder="‘Maiores descontos para toda a sua casa’"
              value={banner1Subtitle}
              onChange={e => setBanner1Subtitle(e.target.value)}
            />
          </InputWrapper>

          <TitleInput>Descanso de Tela 2</TitleInput>

          <InputWrapper>
            <Label>Título do Banner</Label>

            <Input
              minLength={4}
              maxLength={16}
              name="banner2Title"
              placeholder="‘Veja aqui!’"
              value={banner2Title}
              onChange={e => setBanner2Title(e.target.value)}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>Subtítulo do Banner</Label>

            <Input
              maxLength={45}
              name="banner2Subtitle"
              placeholder="‘Maiores descontos para toda a sua casa’"
              value={banner2Subtitle}
              onChange={e => setBanner2Subtitle(e.target.value)}
            />
          </InputWrapper>
        </Content>

        {!loading && !!categories.length && (
          <Button
            fixed
            disabled={
              !(
                storeId &&
                categories.some(category => category.isSelected) &&
                departmentName.trim() &&
                bannerImage &&
                banner1Title.trim() &&
                banner1Subtitle.trim() &&
                banner2Title.trim() &&
                banner2Subtitle.trim()
              )
            }
            onClick={handleSubmit}
            style={{ zIndex: 10 }}
          >
            FINALIZAR
          </Button>
        )}
        <ModalCmp />
      </Container>
      <Footer />
    </>
  );
};

export default Setup;
